import styled from 'styled-components';

export const BookingFormContainer = styled.div`
  display: block;
  position: relative;
  margin-top: 0px;
  padding: 20px;
  border: 2px solid #002f2f;
  border-radius: 10px;
  outline: 5px solid #002f2f;
  outline-offset: 2px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 20px;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

export const WarningText = styled.h6`
  color: #d32f2f;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 500;
`;

export const Title = styled.h1`
  color: #002f2f;
  margin: 0;
  font-size: 32px;
  font-weight: 700;
`;

export const TypeSelectionContainer = styled.div`
  width: 600px;
  margin: 0 auto 20px auto;
  display: flex;
  justify-content: center;
  gap: 10px;
`;

export const TypeButton = styled.button<{ $isSelected: boolean }>`
  background-color: ${(props: { $isSelected: boolean }) => props.$isSelected ? '#002f2f' : '#fff'};
  border: ${(props: { $isSelected: boolean }) => props.$isSelected ? '1px solid white' : '1px solid #002f2f'};
  outline: ${(props: { $isSelected: boolean }) => props.$isSelected ? '3px solid white' : '3px solid #002f2f'};
  outline-offset: 2px;
  border-radius: 10px;
  color: ${(props: { $isSelected: boolean }) => props.$isSelected ? '#fff' : '#002f2f'};
  height: 50px;
  overflow: hidden;

  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background-color: #006262;
    color: #fff;
  }
`;


export const CalendarContainer = styled.div`
  margin: 10px 50;
  overflow-x: auto;
`;

export const CalendarTable = styled.table`
  width: 100%;
  border-collapse: collapse;

`;

export const CalendarCell = styled.td`
  padding: 10px;
`;

export const CalendarButton = styled.button<{ $isSelected: boolean }>`
  width: 100%;
  border: 1px solid #002f2f;
  outline: ${(props: { $isSelected: boolean }) => props.$isSelected ? '2px solid white' : '2px solid #002f2f'};
  outline-offset: 2px;
  border-radius: 5px;
  background-color: ${(props: { $isSelected: boolean }) => props.$isSelected ? '#002f2f' : '#fff'};
  color: ${(props: { $isSelected: boolean }) => props.$isSelected ? '#fff' : '#002f2f'};
 
  height: 30px;

  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background-color: #006262;
    color: #fff;
  }

  &:disabled {
    background-color: #b8c1c1;
    outline: none;
    border: none;
    color: #fff;
    cursor: not-allowed;
  }
`;

export const NavigationContainer = styled.div`
  margin: 10px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const NavigationButton = styled.div`
  cursor: pointer;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
  transition: color 0.3s ease;

  &:hover {
    color: #29860c;
  }
`;

export const TimeSelectionContainer = styled.div`
  margin-top: 20px;
`;

export const TimeTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TimeCell = styled.td`
  padding: 5px;
`;

export const TimeButton = styled.button<{ $isSelected: boolean }>`
  width: 100%;
  border: 1px solid #002f2f;
  outline: ${(props: { $isSelected: boolean }) => props.$isSelected ? '2px solid white' : '2px solid #002f2f'};
  outline-offset: 2px;
  border-radius: 5px;
  background-color: ${(props: { $isSelected: boolean }) => props.$isSelected ? '#002f2f' : '#fff'};
  color: ${(props: { $isSelected: boolean }) => props.$isSelected ? '#fff' : '#002f2f'};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 30px;
  max-width: 100px;
  margin: 5px auto;


  &:hover:not(:disabled) {
    background-color: #006262;
    color: #fff;
  }

  &:hover:not(:disabled) {
    background-color: #006262;
    color: #fff;
  }

  &:disabled {
    background-color: #b8c1c1;
    outline: none;
    border: none;
    color: #fff;
    cursor: not-allowed;
  }
`;

export const FormContainer = styled.div`
  width: 600px;
  margin: 0px auto 10px auto;
  padding-top: 20px;
`;

export const FormTitle = styled.h5`
  color: #002f2f;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 500;
`;

export const FormInput = styled.input`
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  padding: 12px 20px;
  height: 40px;
  width: 100%;
  margin-bottom: 20px;
  background-image: none;
  font-size: 17px;
  line-height: 20px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;

  &:focus {
    border: 1px solid #222;
    background-image: none;
    outline: none;
  }

  &::placeholder {
    color: #a5a5a5;
  }
`;

export const SubmitButton = styled.button`
  margin-top: 20px;
  background-color: #002f2f;
  color: #fff;
  height: 50px;
  width: 100%;
  border: 2px solid #002f2f;
  border-radius: 10px;
  outline: 2px solid #002f2f;
  outline-offset: 2px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background-color: #006262;
    color: #fff;
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const SuccessMessage = styled.h5`
  color: #29860c;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  margin: 20px 0;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;

  ${FormInput} {
    margin-bottom: 0;
  }
`;

// Responsive design
export const ResponsiveContainer = styled.div`
  @media (max-width: 768px) {
    ${TypeSelectionContainer} {
      width: 100%;
      flex-direction: column;
      align-items: center;
    }

    ${TypeButton} {
      width: 100%;
      max-width: 300px;
    }


    ${FormContainer} {
      width: 100%;
      max-width: 400px;
    }

    ${CalendarTable}, ${TimeTable} {
      font-size: 12px;
    }

    ${CalendarButton}, ${TimeButton} {
      height: 40px;
      font-size: 12px;
    }
  }

  @media (max-width: 480px) {
    ${BookingFormContainer} {
      padding: 10px;
    }

    ${Title} {
      font-size: 24px;
    }

    ${CalendarButton}, ${TimeButton} {
      height: 35px;
      font-size: 11px;
    }
  }
`;
